import DocumentViewer from "components/common/DocumentViewer";
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { Button, IconButton } from 'components/common';
import { FaDownload, FaArrowLeft } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { downloadAsset } from "redux/drive/driveSlice";
import './drive-editor.scss';

const DriveDocViewer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { asset, url } = location?.state || {};
  const { allow_download } = asset?.permissions || {};

  const handleDownload = () => {
    dispatch(downloadAsset({ assetId: asset.id, fileName: asset.name }));
  };

  return (
    <div className="drive-editor-page">
      {/* Header — same structure as DriveOnlyOfficeEditor. The `card`/`card-header`
          class names are kept: drive-editor.scss scopes its layout rules to them. */}
      <div className="drive-editor-header tw-border tw-border-solid tw-border-slate-200 tw-bg-white tw-rounded tw-shadow-sm tw-mb-2">
        <div className="tw-border-b tw-border-solid tw-border-slate-200 tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3">
          <IconButton
            icon={<FaArrowLeft size={12} />}
            onClick={() => navigate(-1)}
            variant="secondary"
            size="sm"
            title="Back"
          />

          <div className="drive-editor-title">
            <h6>{asset?.name || 'Document Viewer'}</h6>
            <span className="drive-editor-badge badge-view">View only</span>
          </div>

          {allow_download && (
            <Button
              size="sm"
              variant="ghost"
              onClick={handleDownload}
              title="Download original file"
            >
              <FaDownload className="tw-mr-1" /> Download
            </Button>
          )}
        </div>
      </div>

      {/* Viewer — fills remaining height */}
      <div className="drive-editor-container">
        <div className="tw-border tw-border-solid tw-border-slate-200 tw-flex tw-flex-col tw-bg-white tw-rounded tw-shadow-sm tw-h-full">
          <div className="tw-flex-1 tw-p-4">
            <DocumentViewer document_url={url} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriveDocViewer;
